'use client'

import * as Dialog from '@radix-ui/react-dialog'
import { clsx } from 'clsx'
import * as React from 'react'

export const VideoDialog = ({
  trigger,
  children,
  width,
  height,
  autoOpenQueryParam,
}: {
  trigger: React.ReactNode
  children: React.ReactNode
  width: number
  height: number
  autoOpenQueryParam?: string
}) => {
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (
      autoOpenQueryParam &&
      window.location.search.includes(autoOpenQueryParam)
    ) {
      setOpen(true)
    }
  }, [autoOpenQueryParam])

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-[#000] bg-opacity-40 radix-state-open:animate-overlay-show fixed inset-0 z-overlay" />
        <Dialog.Content
          style={{
            aspectRatio: `${width}/${height}`,
          }}
          className={clsx(
            `w-max max-w-[95vw] max-h-[90vh] h-auto`,
            'radix-state-open:animate-content-show fixed top-1/2 left-1/2 z-modal translate-x-[-50%] translate-y-[-50%] rounded-2xl bg-dark-bg p-3 shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none'
          )}
        >
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
